import { Alert } from 'app/model/shared/alert';
import { AlertType } from './../../model/shared/alert';
import { Component, OnInit, Input, AfterViewChecked } from '@angular/core';

import * as $ from 'jquery';
import { Subject } from 'rxjs/Rx';

@Component({
  selector: 'app-agent-popup-alert',
  templateUrl: './alert.component.html',
  styleUrls: ['./alert.component.css']
})
export class AlertComponent implements OnInit, AfterViewChecked {

  @Input('show') show: boolean;
  @Input('data') data: Alert;

  showChanged: Subject<boolean> = new Subject<boolean>();

  AlertType = AlertType;

  constructor(
  ) {
    this.showChanged.subscribe((isShow) => {
      this.show = isShow;
    });
  }

  ngOnInit() {
  }

  dismissPopup() {
    this.show = false;
    this.ngOnInit();
  }

  ngAfterViewChecked() {
    if (this.show) {
      $('.agent-conatiner #popup-alert button').filter(function() {
        return $(this).text() === 'OK';
      }).focus();
    }
  }

  cbContainer: any;
  confirm(cbObj) {
    cbObj.getContainer().subscribe(container => {
      this.cbContainer = container;
    });
  }

  OKPopup() {
    if (this.cbContainer) {
      this.cbContainer.yesFn();
    }
    this.dismissPopup();
  }

  confirmOnPopup(result: boolean) {
    if (result) {
      this.cbContainer.yesFn();
    } else {
      this.cbContainer.noFn();
    }
    this.dismissPopup();
  }
}



// WEBPACK FOOTER //
// ./src/app/agent/alert/alert.component.ts